module.exports = __webpack_public_path__ + "img/logo.2318d8d9.png";